// extracted by mini-css-extract-plugin
export default {"title":"Title__title___tXkuJ","special":"Title__special___drP2j"};